import * as Yup from 'yup'

Yup.setLocale({
    mixed: {
        required: 'Pole jest wymagane',
    },
    string: {
        email: 'Nieprawidłowy adres e-mail',
    },
})

export const phoneRegex = /(?<!\w)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/
